<template>
  <el-card class="application" shadow="hover">
    <div v-bind:class="classNames" @click="enter">
      <div class="alerts">
        <i v-if="application.config.backup !== '1'" class="mdi mdi-restore-alert" />
      </div>

      <h3>{{ application.alias }}</h3>

      <Screen
        v-loading="loading"
        :element-loading-spinner="spinner"
        :element-loading-text="failed"
        :application="application"
      />

      <el-row :gutter="0">
        <el-col v-if="application.state !== 'running'" :span="24">
          <State :application="application" />
        </el-col>

        <template v-else>
          <el-col :span="12">
            {{ bundleName }}
          </el-col>
          <el-col :span="12">
            {{ application.package || application.version }}
          </el-col>
        </template>
      </el-row>
    </div>
  </el-card>
</template>

<script>
import { mapState } from 'vuex'
import State from './State'
import Screen from './Screen'

export default {
  props: {
    application: Object
  },
  components: {
    State,
    Screen
  },
  computed: {
    bundleName () {
      return this.$root.bundles[this.application.bundleId].name
    },
    classNames () {
      return {
        [this.application.bundleId]: true,
        running: this.application.state === 'running',
        stopped: this.application.state === 'stopped'
      }
    },
    loading () {
      return this.tasks.find((t) => t.applicationId === this.application.id)
    },
    spinner () {
      return this.loading && !!this.loading.exitCode ? 'el-icon-error' : ''
    },
    failed () {
      return this.loading && !!this.loading.exitCode ? 'failed' : ''
    },
    ...mapState(['tasks'])
  },
  methods: {
    enter () {
      if (this.application.state !== 'destroying') {
        this.$router.push('/instances/' + this.application.instanceId + '/' + this.application.id)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../theme";

  .application {
    border: 1px solid $--border-color-base;
    background-color: #fff;;
    cursor: pointer;
    position: relative;

    h3 {
      max-width: 90%;
      margin-top: 10px;
      margin-bottom: 0;
      padding-left: 10px;
      font-size: 12px;
      line-height: 15px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
    }

    .alerts {
      line-height: 15px;
      font-size: 12px;
      position: absolute;
      z-index: 1;
      right: 10px;
      top: 10px;

      .mdi {
        color: $--color-warning;
      }
    }

    .screen {
      box-shadow: 0 0 20px 0 rgba(0,0,0,0.2);
      width: calc(100% - 20%);
      height: 115px;
      margin: 9px 10% -3px;
    }

    .stopped {
      opacity: 0.4;
    }

    .el-row {
      border-top: 1px solid $--border-color-base;
      background-color: #fff;
      margin: 0 !important;

      .el-col {
        padding: 5px 10px;
        color: #777;
        font-weight: 400;
        font-size: 12px;
        line-height: 22px;
        min-height: 32px;

        &:nth-child(2n) {
          text-align: right;
        }
      }
    }

    &:hover {
      background-color: #fcfcfc;
    }
  }
</style>

<style lang="scss">
  #applications {
    .application {
      h3 {
        font-size: 11px;
      }
      .screen {
        margin-top: 10px;
      }
    }
  }
  .el-card.application > .el-card__body {
    padding: 0;
  }
</style>
